import Popover from 'trunks/vue/admin/components/libs/popover.js'
import { newAlertify } from 'trunks/vue/admin/components/alert.js'
import SuperiorModal from './superior_modal.js'

export default Vue.extend({
  components: {
    Popover
  },

  props: {
    namespace: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      superiors: [],
      loading: true
    }
  },

  template: `
    <div class="panel-card namespaces-subpanel">
      <div class="panel-card-head">
        <span class="panel-card-title">超级管理员</span>
        <div class="panel-card-actions">
          <button class="text-btn btn-primary" @click="openCreate">
            <i class="slp-plus-circle"></i>
            <span>新建超管</span>
          </button>
        </div>
      </div>
      <div class="panel-card-body">
        <div v-if="loading" class="text-muted">加载中...</div>
        <div v-else-if="superiors.length === 0" class="text-muted">尚未设置超级管理员</div>
        <table v-else class="table table-noborder table-striped">
          <thead>
            <tr>
              <th>姓名</th>
              <th>识别码</th>
              <th>手机号</th>
              <th class="operation-col">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="superior in superiors" :key="superior.id">
              <td>{{ superior.name }}</td>
              <td>{{ superior.identifier }}</td>
              <td>{{ superior.phone || '—' }}</td>
              <td class="operation-col">
                <a :href="loginUrl(superior)"
                   data-method="post"
                   rel="nofollow"
                   data-turbolinks="false"
                   class="btn-text primary-text mr-3">登录</a>
                <span class="btn-text primary-text mr-3" @click="openEdit(superior)">编辑</span>
                <Popover position="bottom right"
                         customClass="confirm table-operation-confirm-popover delete-confirm-popover"
                         :ref="cancelRefName(superior)">
                  <template slot="trigger">
                    <span class="btn-text error-text mr-3">移除</span>
                  </template>
                  <template slot="content">
                    <div class="popover-confirm-content">
                      <div class="popover-confirm-title">确认移除超级管理员？</div>
                      <div class="popover-confirm-message text-muted">仅取消其超管资格，不删除该用户。</div>
                      <div class="popover-confirm-footer">
                        <span class="btn btn-small btn-default outlined" @click.stop="closeCancel(superior)">取消</span>
                        <span class="btn btn-small btn-danger" @click.stop="cancelSuperior(superior)">移除</span>
                      </div>
                    </div>
                  </template>
                </Popover>
                <Popover position="bottom right"
                         customClass="confirm table-operation-confirm-popover delete-confirm-popover"
                         :ref="destroyRefName(superior)">
                  <template slot="trigger">
                    <span class="btn-text error-text">彻底删除</span>
                  </template>
                  <template slot="content">
                    <div class="popover-confirm-content">
                      <div class="popover-confirm-title">确定彻底删除该超管？</div>
                      <div class="popover-confirm-message text-danger">将同时删除该超管创建的组织及其下属组织。</div>
                      <div class="popover-confirm-footer">
                        <span class="btn btn-small btn-default outlined" @click.stop="closeDestroy(superior)">取消</span>
                        <span class="btn btn-small btn-danger" @click.stop="destroySuperior(superior)">删除</span>
                      </div>
                    </div>
                  </template>
                </Popover>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,

  created() {
    this._fetchSuperiors()
  },

  methods: {
    _fetchSuperiors() {
      this.loading = true
      Skylark.Libs.Ajax.get(`${this.namespace.urls.superiors}.json`, {
        responseType: 'json',
        success: (data) => {
          this.superiors = data || []
        },
        complete: () => {
          this.loading = false
        }
      })
    },

    loginUrl(superior) {
      return `/admin/login_as_root/${superior.id}`
    },

    cancelRefName(superior) {
      return `cancelPopover-${superior.id}`
    },

    destroyRefName(superior) {
      return `destroyPopover-${superior.id}`
    },

    closeCancel(superior) {
      const ref = this.$refs[this.cancelRefName(superior)]
      const popover = Array.isArray(ref) ? ref[0] : ref
      if (popover) popover.close()
    },

    closeDestroy(superior) {
      const ref = this.$refs[this.destroyRefName(superior)]
      const popover = Array.isArray(ref) ? ref[0] : ref
      if (popover) popover.close()
    },

    openCreate() {
      new SuperiorModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('superior_create_modal_container'),
        propsData: {
          namespace: this.namespace,
          mode: 'create',
          superior: { name: '', identifier: '', phone: '' },
          onSuccess: (data) => {
            this.superiors = [data].concat(this.superiors)
          }
        }
      })
    },

    openEdit(superior) {
      new SuperiorModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('superior_edit_modal_container'),
        propsData: {
          namespace: this.namespace,
          mode: 'edit',
          superior: _.clone(superior),
          onSuccess: (data) => {
            const index = _.findIndex(this.superiors, { id: data.id })
            if (index >= 0) Vue.set(this.superiors, index, data)
          }
        }
      })
    },

    cancelSuperior(superior) {
      Skylark.Libs.Ajax.patch(`${this.namespace.urls.superiors}/${superior.id}/remove`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          this.superiors = this.superiors.filter((item) => item.id !== superior.id)
          newAlertify('已移除超级管理员', { type: 'success' })
        },
        error: () => {
          newAlertify('移除失败，请重试', { type: 'error' })
        },
        complete: () => {
          this.closeCancel(superior)
        }
      })
    },

    destroySuperior(superior) {
      Skylark.Libs.Ajax.delete(`${this.namespace.urls.superiors}/${superior.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          this.superiors = this.superiors.filter((item) => item.id !== superior.id)
          newAlertify('已删除超级管理员', { type: 'success' })
        },
        error: () => {
          newAlertify('删除失败，请重试', { type: 'error' })
        },
        complete: () => {
          this.closeDestroy(superior)
        }
      })
    }
  }
})
